export const publicRoutePaths = [
  '/',
  '/about',
  '/admin-login',
  '/causes',
  '/donate',
  '/forgot',
  '/forgot-password',
  '/honoree',
  '/login',
  '/memoriam',
  '/og',
  '/privacy',
  '/raffles',
  '/register',
  '/reset',
  '/reset-password',
  '/signup',
  '/terms',
  '/thank-you',
  '/wheel',
  '/team-picker-preview',
  '/welcome/vendor-inquiry',
]

const publicRoutePrefixes = [
  '/invite/',
  '/public/',
]

export function isPublicRoutePath(path: string) {
  return publicRoutePaths.includes(path)
    || publicRoutePrefixes.some(prefix => path.startsWith(prefix))
}
